import { Component, HostBinding, OnInit } from '@angular/core';
import { UpdateService } from '../../../core/services/update.service';
import { delay } from 'rxjs/operators';

enum Display {
	NONE = 'none',
	BLOCK = 'block'
}

@Component({
	selector: 'app-update-bar',
	templateUrl: './update-bar.component.html',
	styleUrls: [ './update-bar.component.scss' ]
})
export class UpdateBarComponent implements OnInit {
	@HostBinding('style.display') display: Display = Display.NONE;

	constructor(private readonly updateService: UpdateService) {
	}

	public ngOnInit(): void {
		this.listenForUpdates();
	}

	public async update(): Promise<void> {
		await this.updateService.update();
		this.display = Display.NONE;
	}

	public close(): void {
		this.display = Display.NONE;
	}

	private listenForUpdates(): void {
		this.updateService.updateAvailable$.pipe(
			delay(this.updateService.delayForShowingUpdateBar)
		).subscribe((updateAvailable: boolean) => {
			if (updateAvailable) {
				this.display = Display.BLOCK;
			}
		});
	}
}
